import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const RedirectPage = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const link = params.get("link");
    if (link) {
      window.location.href = link; // abre direto sem bloqueio
    }
  }, [location]);

  return null;
};

export default RedirectPage;
